import React from 'react';
import {
  Text,
  FormControl,
  FormErrorMessage,
  Select as ChakraSelect,
  SelectProps as ChakraSelectProps,
} from '@chakra-ui/react';
import { FieldError, UseFormRegister } from 'react-hook-form';

interface SelectProps extends ChakraSelectProps {
  name: string;
  label?: string;
  error?: FieldError;
  register?: UseFormRegister<any>;
  flexDir?: 'row' | 'column';
  alignItems?: string;
  formControlWidth?: string;
  formControlJustifyContent?: string;
  isRowSelect?: boolean;
}

export const Select: React.FC<SelectProps> = ({
  children,
  name,
  register = () => ({}),
  error = null,
  label,
  flexDir = 'column',
  alignItems = 'normal',
  formControlWidth = 'auto',
  formControlJustifyContent = 'normal',
  isRowSelect = false,
  ...props
}) => {
  return !isRowSelect ? (
    <FormControl display="flex" flexDir="column" isInvalid={!!error}>
      {label && (
        <Text fontSize="14px" mb={2} fontWeight="medium">
          {label} {props.isRequired && <span style={{ color: 'red' }}>*</span>}
        </Text>
      )}

      <ChakraSelect
        bg="gray.100"
        borderColor="gray.300"
        _hover={{
          borderColor: 'gray.500',
        }}
        _placeholder={{
          color: 'gray.500',
        }}
        {...props}
        {...register(name)}
      >
        {children}
      </ChakraSelect>
      {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  ) : (
    <FormControl
      display="flex"
      isInvalid={!!error}
      w={formControlWidth}
      justifyContent={formControlJustifyContent}
      flexDir="row"
      alignItems="baseline"
    >
      {label && (
        <Text fontSize="14px" mb={2} fontWeight="medium">
          {label}
        </Text>
      )}

      <ChakraSelect
        bg="gray.100"
        borderColor="gray.300"
        _hover={{
          borderColor: 'gray.500',
        }}
        _placeholder={{
          color: 'gray.500',
        }}
        {...props}
        {...register(name)}
      >
        {children}
      </ChakraSelect>
      {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  );
};
